import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Http } from '@angular/http';
import { DataService } from '../services/data.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DashboardDataUtility } from '../utils/data.calculate';
//import { ChangeDetectorRef } from '@angular/core/src/change_detection/change_detector_ref';
//import { DashboardDataUtility } from '../utils/data.calculate';
//import { DataStore } from '../utils/utils';

const RE_RENDER_TABLE = "rerender-table";

@Component({
    selector: 'my-table',
    template: require('./tableView.html'),
    styles: [require('./tableView.css')]
})
export class TableView implements OnInit {
    private tableData: string = "Hello";
    private warehouseData: any;
    @Input() calculatedData: Array<any>;
    @Input() questionsString: string;
    @Input() questionLabels: string;
    @Input() activeDashboard: any;
    @Input() selectedComponent: any;
    @Input() selectedCompType: any;
    @Input() tableTitle: string;
    @Input() chartData: any;
    @Input() dataFormat: string;
    @Input() moment: any;
    @Input() columnType: any;
    @Input() stackArray: any;

    private questionsArray: Array<string> = [];
    public questionsLabels: Array<string> = [];
    private currentEuCsvUrl: string;
    private currentUsCsvUrl: string;
    private euCsvUrl: SafeUrl;
    private usCsvUrl: SafeUrl;
    private total: Array<any> = [];
    private showTotal: boolean = false;
    private component: any;
    private showQuestion: boolean = false;
    private showMultiCount: boolean = false;
    private showDefaultTable: boolean = false;

    constructor(private dataService: DataService, private sanitizer: DomSanitizer, public dashboardDataUtil: DashboardDataUtility) { }

    ngOnInit() {
        console.log("table view called");
        if (this.moment && !this.moment.aggregateData) {
            this.calculatedData = [this.dashboardDataUtil.getSeriesQuestionValueSum(this.moment.jsonData, this.moment.questionsArray)];
            if (this.moment.tableRowLabel) {
                this.calculatedData[0]["fromDate"] = this.moment.tableRowLabel;
            }
        }

        this.customizeCalculatedData();
        this.getCSVURL();

        this.dataService.getObservable(RE_RENDER_TABLE).subscribe((result) => {
            this.calculatedData = result;
            this.questionsLabels = [];
            this.questionsArray = [];
            this.showTotal = null;
            this.total = [];

            if (this.selectedCompType === "moments") {
                this.chartData = result.chartData;
                this.calculatedData = result.data;
                this.questionsString = result.questionString;
                this.dataFormat = result.dataFormat;
                if (!result.aggregateData && result.tableRowLabel) {
                    this.calculatedData[0]["fromDate"] = result.tableRowLabel;
                }
            }

            this.customizeCalculatedData();
            this.getCSVURL();
        });

       

        if(this.columnType === "questions")
            this.showQuestion = true;
        else if(this.columnType === "multiattempt")
            this.showMultiCount = true;
        else 
            this.showDefaultTable = true;
        //this.warehouseData = this.dashboard.calculatedWarehouseData;
    }

    customizeCalculatedData() {
        if (this.activeDashboard && this.activeDashboard.components) {
            for (var i = 0; i < this.activeDashboard.components.length; i++) {
                if (this.activeDashboard.components[i].name === this.selectedComponent) {
                    this.component = this.activeDashboard.components[i];
                    break;
                }
            }
        }

        if (typeof this.component == 'undefined') {
            this.component = {};
        }

        if (this.selectedCompType === "moments") {
            this.component = this.chartData;
        }
        //var component = (this.activeDashboard && this.activeDashboard.components[0] ? this.activeDashboard.components[0] : {});

        this.showTotal = this.component.showTotal;
        this.questionsArray = this.component.order;

        if (this.showTotal) {
            if (this.columnType == "questions") {
                this.total.push({});
                for (let i = 0; i < this.questionsArray.length; i++) {
                    this.total[0][this.questionsArray[i]] = 0;
                    for (let m = 0; m < this.stackArray.length; m++) {
                        for (let j = 0; j < this.calculatedData.length; j++) {
                            if (this.questionsArray[i] == this.calculatedData[j]['QuestionKey']) {
                                this.total[0][this.questionsArray[i]] += this.calculatedData[j][this.stackArray[m]];
                            }
                        }
                    }
                }
                this.component.total = this.total;
            }
            else if(this.columnType === "multiattempt") {
                this.total.push({});
                let totCount = 0;
                
                for (let j = 0; j < this.calculatedData[0].length; j++) {
                    let index = this.calculatedData[0][j];
                    totCount += this.calculatedData[1][this.stackArray + "-" + index];
                }
                this.total[0] = totCount;             
                this.component.total =  this.total;
            }
            else {
                var questionLabels = this.questionsString.split(',');
                this.total.push({});
                for (var k = 0; k < questionLabels.length; k++) {
                    this.total[0][questionLabels[k]] = 0;
                }

                for (var j = 0; j < this.calculatedData.length; j++) {
                    for (var k = 0; k < questionLabels.length; k++) {
                        this.total[0][questionLabels[k]] += this.calculatedData[j][questionLabels[k]];
                    }
                }
                this.component.total = this.total;
            }
        }

        if (this.component.custom && this.component.custom.length > 0) {
            for (var i = 0; i < this.component.custom.length; i++) {

                var formulae = this.component.custom[i].formulae;
                var regex = /'(.*?[^\\])'/g;
                let tempArray: Array<string> = formulae.match(regex);
                let keysArray: Array<string> = [];

                for (var k = 0; k < tempArray.length; k++) {
                    keysArray.push(tempArray[k].substring(1, tempArray[k].length - 1));
                    //formulae = formulae.replace(tempArray[0], "");
                }

                this.addCustomRateToData(i, this.component, this.calculatedData, tempArray, keysArray);
                if (this.showTotal) {
                    this.addCustomRateToData(i, this.component, this.total, tempArray, keysArray);
                }
            }
        }

        this.createQuestionLabels();

        if (this.columnType !== "questions") {
            if (this.selectedComponent === 'scorecomposition' || (this.dataFormat && this.dataFormat === 'percent')) {
                var total;
                for (var i = 0; i < this.calculatedData.length; i++) {
                    total = 0;
                    for (var j = 0; j < this.questionsArray.length; j++) {
                        total += this.calculatedData[i][this.questionsArray[j]];
                    }

                    if (total !== 0) {
                        for (var k = 0; k < this.questionsArray.length; k++) {
                            var formattedNo = (this.calculatedData[i][this.questionsArray[k]] / total) * 100;

                            if (formattedNo % 1 !== 0) {
                                this.calculatedData[i][this.questionsArray[k]] = formattedNo.toFixed(2).toString() + '%';
                            }
                            else {
                                this.calculatedData[i][this.questionsArray[k]] = formattedNo.toString() + '%';
                            }
                        }
                    }
                    else {
                        for (var k = 0; k < this.questionsArray.length; k++) {
                            this.calculatedData[i][this.questionsArray[k]] = (this.calculatedData[i][this.questionsArray[k]]).toString() + '%';
                        }
                    }
                }
            }
        }
    }

    addCustomRateToData(i, component: any, data: Array<any>, tempArray: Array<string>, keysArray: Array<string>) {
        for (var j = 0; j < data.length; j++) {
            var formulae = component.custom[i].formulae;
            for (var k = 0; k < tempArray.length; k++) {
                formulae = formulae.replace(tempArray[k], data[j][keysArray[k]]);
            }

            var completionRate = eval(formulae);
            if (isNaN(completionRate) || !isFinite(completionRate)) {
                completionRate = 0
            }
            data[j][component.custom[i].key] = completionRate.toFixed(2);
        }
    }

    createQuestionLabels() {
        var component = this.component;

        for (var i = 0; i < this.questionsArray.length; i++) {
            for (var j = 0; j < component.series.length; j++) {
                if (this.questionsArray[i] === component.series[j].key) {
                    this.questionsLabels.push(component.series[j].label);
                }
            }
            if (component.custom && component.custom.length > 0) {
                for (var j = 0; j < component.custom.length; j++) {
                    if (this.questionsArray[i] === component.custom[j].key) {
                        this.questionsLabels.push(component.custom[j].label);
                    }
                }
            }
        }
    }

    getCSVURL() {
        // Clear memory of previous blobs
        if (this.currentEuCsvUrl) {
            URL.revokeObjectURL(this.currentEuCsvUrl)
        }
        if (this.currentUsCsvUrl) {
            URL.revokeObjectURL(this.currentUsCsvUrl)
        }

        let csvData = this.getCSVData(',');
        let csvBlob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });

        this.currentUsCsvUrl = URL.createObjectURL(csvBlob);
        this.usCsvUrl = this.sanitizer.bypassSecurityTrustUrl(this.currentUsCsvUrl);

        csvData = this.getCSVData(';');
        csvBlob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });

        this.currentEuCsvUrl = URL.createObjectURL(csvBlob);
        this.euCsvUrl = this.sanitizer.bypassSecurityTrustUrl(this.currentEuCsvUrl);
    }

    getCSVData(delimiter = ',') {
        if (this.columnType === "questions") {
            let csvHeader = [' '].concat(this.questionsLabels).map(this.quoteString).join(delimiter);
            let csvEntries = this.buildCSVRowForQuestions(delimiter);
            return (csvHeader + '\n' + csvEntries);
        }
        else if(this.columnType === "multiattempt") {
            let csvHeader = [' '].concat(this.questionsLabels).map(this.quoteString).join(delimiter);
            let csvEntries = ""
            for(let i =0; i < this.calculatedData[0].length; i++) {
                let col = this.stackArray + "-" + this.calculatedData[0][i];
                csvEntries += col + delimiter;
                csvEntries += this.quoteString(this.calculatedData[1][col]) + delimiter;
                csvEntries += '\n';
            }
            if(this.showTotal) {
                csvEntries += "Total" + delimiter;
                csvEntries += this.component.total;
            }
        
            return (csvHeader + '\n' + csvEntries);
        }
        else {
            let csvHeader = ['Date'].concat(this.questionsLabels).map(this.quoteString).join(delimiter);
            let csvEntries = this.calculatedData.map((datum) => {
                return this.buildCsvRow(datum, this.questionsArray).join(delimiter);
            }).join('\n');
            return (csvHeader + '\n' + csvEntries);
        }
    }

    buildCSVRowForQuestions(delimiter) {
        let csvEntrie = ""
        for (let i = 0; i < this.stackArray.length; i++) {
            csvEntrie += this.stackArray[i] + delimiter;
            for (let j = 0; j < this.questionsArray.length; j++) {
                for (let m = 0; m < this.calculatedData.length; m++) {
                    if (this.questionsArray[j] == this.calculatedData[m]["QuestionKey"]) {
                        csvEntrie += this.quoteString(this.calculatedData[m][this.stackArray[i]]) + delimiter;
                    }
                }
            }
            csvEntrie += '\n';
        }

        if(this.showTotal) {
            csvEntrie += "Total" + delimiter
            let total = this.component.total[0];        
            this.questionsArray.map((dnum) => {
                csvEntrie += this.quoteString(total[dnum]) + delimiter;
            });
        }        
        return csvEntrie;
    }

    buildCsvRow(datum, questionsArray) {
        let date = [datum.fromDate];
        let row = questionsArray.map(q => datum[q]);
        return date.concat(row).map(this.quoteString);
    }

    quoteString(str) {
        if (typeof str == "string" || isNaN(parseFloat(str))) {
            return '"' + str + '"'
        } else {
            return str
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/datawarehousetable/tableView.ts